// ----------------------------------------------------------------------
// <copyright file="Izenda.Source.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * Source component
 */
!(function () {
  "use strict";

  var m = require('mobx');
  var React = require('react');
  var EventUtils = require('EventUtils');
  var connect = require('share/enhancers/Izenda.Connect');
  var commonMessages = require('share/messages/Izenda.CommonMessages');

  var DropDown = require('share/components/controls/Izenda.DropDown');

  var Source = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired,
      title: React.PropTypes.string.isRequired
    },

    render: function () {
      var props = this.props;
      var store = props.store;

      return (
        <div className='u_table u_fullWidth'>
          <div className='u_tableCell u_alignMiddle'>
            {this.props.title}
          </div>
          <div className='u_tableCell u_fullWidth u_paddingLeft'>
            <DropDown options={props.store.masterStore.availableSources}
              onChange={EventUtils.notifyChange(this.onChangeSourceDropDown, EventUtils.DROPDOWN) }
              value={props.store.item.sourceId}
              valueField="id" labelField="name" />
          </div>
        </div>
      );
    },

    onChangeSourceDropDown: m.action(function (sourceId) {
      var props = this.props;
      var store = props.store;
      var loader = props.loader;
      var item = store.item;

      item.setAlertMessage(commonMessages.EMPTY_MESSAGE);
      item.setSource(sourceId);
      item.resetWorkspaceTenantsStatus();
      loader.startLoading();
      item.updateDataForDestination(sourceId);
      item.updateSelectedTenantsForDestination(item.selectedDestinationTenantIDs, sourceId);

      Promise.all([
        store.loadSourceConnections(sourceId),
        store.loadRolesAndPermissions(sourceId)        
      ]).then(function () {
        // load source for copy reports - need to load source connection first
        store.loadReports(sourceId, item.copyReport);
        store.loadDashboards(sourceId, item.copyDashboard);
        return null;
      }).finally(loader.endLoading.bind(loader));
    })
  });

  module.exports = connect()(Source);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/AdditionalItems/Izenda.Source.jsx